import React from "react";

function CaughtUp() {
  return (
    <svg viewBox="0 0 389 316" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#prefix__clip0)">
        <path
          d="M161.538 316c16.155 0 29.251-3.383 29.251-7.555 0-4.173-13.096-7.555-29.251-7.555-16.156 0-29.252 3.382-29.252 7.555 0 4.172 13.096 7.555 29.252 7.555zM163.721 232.45c16.155 0 29.251-3.382 29.251-7.555 0-4.172-13.096-7.555-29.251-7.555s-29.252 3.383-29.252 7.555c0 4.173 13.097 7.555 29.252 7.555zM29.251 236.006c16.155 0 29.252-3.383 29.252-7.555 0-4.173-13.096-7.555-29.252-7.555-16.155 0-29.251 3.382-29.251 7.555 0 4.172 13.096 7.555 29.251 7.555z"
          fill="#F2F2F2"
        />
        <path d="M177.089 1.778H9.875v6.444H177.09V1.778z" fill="#F5F5F5" />
        <path
          d="M179.708 0H6.819v215.985h172.889V0z"
          fill="url(#prefix__paint0_linear)"
        />
        <path d="M177.089 8.222H9.875V212.43H177.09V8.222z" fill="#fff" />
        <path
          d="M13.316 6.666c.844 0 1.528-.696 1.528-1.555 0-.86-.684-1.556-1.528-1.556s-1.528.697-1.528 1.556c0 .859.684 1.555 1.528 1.555z"
          fill="#FF5252"
        />
        <path
          d="M17.516 6.666c.844 0 1.528-.696 1.528-1.555 0-.86-.684-1.556-1.528-1.556s-1.528.697-1.528 1.556c0 .859.684 1.555 1.528 1.555z"
          fill="#FF0"
        />
        <path
          d="M21.72 6.666c.844 0 1.529-.696 1.529-1.555 0-.86-.685-1.556-1.529-1.556-.843 0-1.528.697-1.528 1.556 0 .859.684 1.555 1.528 1.555z"
          fill="#69F0AE"
        />
        <path
          opacity={0.2}
          d="M79.73 15.999H14.678v4H79.73v-4z"
          fill="#BE6F72"
        />
        <path d="M126.008 32.442H60.956v4h65.052v-4z" fill="#F5F5F5" />
        <path
          opacity={0.5}
          d="M79.73 161.322H14.678v4H79.73v-4z"
          fill="#BE6F72"
        />
        <path
          d="M110.291 160.878h-21.83v4.888h21.83v-4.888z"
          fill="url(#prefix__paint1_linear)"
        />
        <path
          d="M110.291 185.765h-21.83v4.888h21.83v-4.888z"
          fill="url(#prefix__paint2_linear)"
        />
        <path
          d="M154.823 185.765h-21.83v4.888h21.83v-4.888z"
          fill="url(#prefix__paint3_linear)"
        />
        <path
          d="M109.854 161.322h-20.52v4h20.52v-4zM109.854 186.209h-20.52v4h20.52v-4zM153.95 186.209h-20.52v4h20.52v-4z"
          fill="#BE6F72"
        />
        <path d="M79.73 173.766H14.678v3.999H79.73v-3.999z" fill="#F5F5F5" />
        <path
          opacity={0.5}
          d="M154.386 173.766H89.335v3.999h65.051v-3.999z"
          fill="#BE6F72"
        />
        <path d="M154.386 198.653H89.335v3.999h65.051v-3.999z" fill="#F5F5F5" />
        <path
          opacity={0.5}
          d="M79.73 186.209H14.678v4H79.73v-4z"
          fill="#BE6F72"
        />
        <path
          d="M79.73 198.653H14.678v3.999H79.73v-3.999zM97.63 39.108H60.957v4H97.63v-4zM116.84 39.108h-12.661v4h12.661v-4zM97.63 52.44H60.957v4H97.63v-4zM116.84 52.44h-12.661v4h12.661v-4zM126.008 45.775H60.956v4h65.052v-4z"
          fill="#F5F5F5"
        />
        <path
          opacity={0.2}
          d="M171.413 15.999h-65.052v4h65.052v-4z"
          fill="#BE6F72"
        />
        <path
          d="M150.894 31.998h-7.859v4.888h7.859v-4.888z"
          fill="url(#prefix__paint4_linear)"
        />
        <path
          d="M150.894 38.664h-7.859v4.889h7.859v-4.89z"
          fill="url(#prefix__paint5_linear)"
        />
        <path
          d="M150.894 45.33h-7.859v4.889h7.859V45.33z"
          fill="url(#prefix__paint6_linear)"
        />
        <path d="M150.457 32.442h-6.985v4h6.985v-4z" fill="#FF5252" />
        <path d="M150.457 39.108h-6.985v4h6.985v-4z" fill="#FF9800" />
        <path d="M150.457 45.775h-6.985v4h6.985v-4z" fill="#69F0AE" />
        <path
          d="M150.894 51.996h-7.859v4.889h7.859v-4.889z"
          fill="url(#prefix__paint7_linear)"
        />
        <path d="M150.457 52.44h-6.985v4h6.985v-4z" fill="#BE6F72" />
        <path
          d="M173.596 80.883H13.368v66.662h160.228V80.883z"
          fill="url(#prefix__paint8_linear)"
        />
        <path
          opacity={0.5}
          d="M171.413 82.216H14.678v63.107h156.735V82.216z"
          fill="#BE6F72"
        />
        <path
          opacity={0.5}
          d="M19.48 87.105h151.933v-4.889H14.678v63.107h4.803V87.105z"
          fill="#fff"
        />
        <path
          d="M175.052 76.695L14.18 91.598l6.014 67.273 160.873-14.903-6.015-67.273z"
          fill="url(#prefix__paint9_linear)"
        />
        <path
          d="M173.035 78.662l-156.09 14.46 5.619 62.847 156.09-14.46-5.619-62.847z"
          fill="#fff"
        />
        <path
          opacity={0.5}
          d="M28.596 144.696L25.89 109.69s13.97-15.11 42.174-3.911 41.502 3.293 46.086-4.271c4.584-7.563 28.379-15.998 36.089-3.346 7.71 12.652 16.957-1.573 16.957-1.573l3.126 34.962-141.726 13.145z"
          fill="#BE6F72"
        />
        <path
          d="M42.799 102.064l.236 2.658"
          stroke="#BE6F72"
          strokeMiterlimit={10}
        />
        <path
          d="M43.493 109.814l2.506 28.025"
          stroke="#BE6F72"
          strokeMiterlimit={10}
          strokeDasharray="11.51 11.51"
        />
        <path
          d="M46.226 140.386l.24 2.653M69.644 106.401l.24 2.654"
          stroke="#BE6F72"
          strokeMiterlimit={10}
        />
        <path
          d="M70.4 114.836l1.812 20.226"
          stroke="#BE6F72"
          strokeMiterlimit={10}
          strokeDasharray="13.06 13.06"
        />
        <path
          d="M72.47 137.95l.235 2.658M97.036 111.148l.262 2.653"
          stroke="#BE6F72"
          strokeMiterlimit={10}
        />
        <path
          d="M97.722 118.134l1.475 15.154"
          stroke="#BE6F72"
          strokeMiterlimit={10}
          strokeDasharray="9.79 9.79"
        />
        <path
          d="M99.411 135.453l.258 2.657M121.655 95.478l.236 2.657"
          stroke="#BE6F72"
          strokeMiterlimit={10}
        />
        <path
          d="M122.336 103.126l2.458 27.46"
          stroke="#BE6F72"
          strokeMiterlimit={10}
          strokeDasharray="11.28 11.28"
        />
        <path
          d="M125.017 133.08l.24 2.657M139.424 91.811l.236 2.653"
          stroke="#BE6F72"
          strokeMiterlimit={10}
        />
        <path
          d="M140.132 99.744l2.598 29.034"
          stroke="#BE6F72"
          strokeMiterlimit={10}
          strokeDasharray="11.93 11.93"
        />
        <path
          d="M142.965 131.417l.24 2.654"
          stroke="#BE6F72"
          strokeMiterlimit={10}
        />
        <path
          d="M42.914 104.106c1.201-.111 2.086-1.192 1.977-2.414-.11-1.222-1.172-2.123-2.372-2.012-1.201.111-2.086 1.192-1.976 2.415.109 1.222 1.17 2.122 2.371 2.011z"
          fill="#FF9800"
        />
        <path
          d="M69.634 108.772c1.2-.111 2.085-1.192 1.976-2.414-.11-1.222-1.171-2.123-2.372-2.011-1.2.111-2.085 1.192-1.976 2.414.11 1.222 1.171 2.123 2.372 2.011z"
          fill="#FF5252"
        />
        <path
          d="M97.228 113.354c1.2-.111 2.085-1.192 1.976-2.414-.11-1.222-1.171-2.123-2.372-2.012-1.2.111-2.085 1.192-1.976 2.415.11 1.222 1.171 2.122 2.372 2.011z"
          fill="#69F0AE"
        />
        <path
          d="M121.772 98.585c1.681-.155 2.919-1.669 2.766-3.38-.153-1.71-1.639-2.972-3.32-2.816-1.681.156-2.92 1.67-2.767 3.38.153 1.711 1.64 2.972 3.321 2.816z"
          fill="url(#prefix__paint10_linear)"
        />
        <path
          d="M139.874 95.125c1.681-.155 2.92-1.669 2.767-3.38-.153-1.71-1.64-2.972-3.321-2.816-1.681.156-2.919 1.67-2.766 3.38.153 1.711 1.639 2.972 3.32 2.816z"
          fill="url(#prefix__paint11_linear)"
        />
        <path
          d="M121.693 97.7c1.2-.111 2.085-1.192 1.976-2.414-.109-1.222-1.171-2.123-2.372-2.012-1.201.111-2.085 1.192-1.976 2.415.109 1.222 1.171 2.122 2.372 2.011zM139.795 94.24c1.201-.111 2.086-1.192 1.976-2.414-.109-1.222-1.171-2.123-2.371-2.012-1.201.112-2.086 1.192-1.977 2.415.11 1.222 1.172 2.122 2.372 2.011z"
          fill="#BE6F72"
        />
        <path
          d="M167.463 99.709c1.201-.112 2.086-1.193 1.976-2.415-.109-1.222-1.171-2.123-2.371-2.011-1.201.111-2.086 1.192-1.977 2.414.11 1.222 1.172 2.123 2.372 2.012z"
          fill="#69F0AE"
        />
        <path
          opacity={0.2}
          d="M171.693 141.643l.03.103c.337-.192-.03-.103-.03-.103z"
          fill="url(#prefix__paint12_linear)"
        />
        <path
          opacity={0.2}
          d="M168.078 216.296l7.107-1.169-.978-4.444v-.062h-.026l-5.038-23.554V169.89a6.477 6.477 0 00-.035-.653c7.527-10.159 3.056-26.1 2.619-27.491-.078.04-.196.093-.362.16a9.468 9.468 0 00-.345-1.836s-2.183-1.413-3.375.405c-1.039 1.586-.266 2.555-.052 2.782l-.149.048c.335.536.569 1.129.69 1.751a3.922 3.922 0 00-.235-.444 5.444 5.444 0 01-.437-.093l-.052-.049-.149.049c.755 1.124 1.022 3.111.987 5.466a7.717 7.717 0 00-.873-1.027 7.637 7.637 0 00-5.108-2.168h-.363a4.39 4.39 0 00-.594.04h-.148l-.249.035-.284.054-.205.044-.354.098-.13.04a7.06 7.06 0 00-.437.155 7.44 7.44 0 01-1.498.551c-.069 0-.139 0-.214.023a2.468 2.468 0 01-1.637-.476l-.157-.124a2.404 2.404 0 01-.17-.165c-.059.154-.085.32-.074.485a1.494 1.494 0 00.781 1.195c.144.077.301.122.463.133h.166-.039a3.779 3.779 0 01-.306.134h-.022a3.712 3.712 0 01-2.087.133l-.188-.044c-.091-.027-.187-.054-.275-.085.029.067.061.132.096.196l.035.057.079.125.048.062.087.111.053.058.109.111.044.04.161.138.057.04.118.084.078.049.105.062.087.045.11.049.091.04.122.044.153.045.114.031h.759c.226-.02.447-.076.655-.165l-.401.169-.201.071-.205.076-.206.062-.209.062-.205.054-.219.053-.2.04-.232.04-.192.031-.249.031h-1.048c.242.072.466.193.66.356.125.092.261.166.406.222.064.019.13.034.196.044h.978a2.83 2.83 0 011.131.369c.184.121.348.271.484.445-.061.102-.122.2-.174.306-.053.107-.092.178-.136.271a5.67 5.67 0 00-.231.565 6.326 6.326 0 00-.375 2.155v.516c0 .106.011.213.035.32v.084c.017.13.04.259.069.387v.075c.024.107.05.212.079.316l.026.093c.074.251.163.498.266.738l.031.071c.05.11.1.216.153.32v.031c.064.119.131.236.201.351v.027c.064.106.132.21.205.311l.026.035a6.2 6.2 0 002.157 1.885 2.809 2.809 0 00-.048.289c-.005.1-.005.201 0 .302v2.346a6.143 6.143 0 00-.384.227c-5.471-2.529-13.618-20.443-13.618-20.443h-.196c.795-.604 0-3.235 0-3.235a3.69 3.69 0 00-1.528-.516H143.55l-.087.027h-.044l-.131.049-.122.057-.044.023-.083.049-.057.271-.078.053-.048.04-.074.062-.048.045-.075.071-.043.049-.075.088-.034.045-.11.151c-1.191 1.818 0 2.831 0 2.831a18.61 18.61 0 00-.109 2.111c-.087 13.092 13.679 23.238 14.381 23.745-.31.818-2.868 8.062.031 17.105a.325.325 0 00.035.063 26.312 26.312 0 00-7.108 11.371 26.712 26.712 0 00-.628 13.462l.056.271h.127a2.05 2.05 0 01-.175.489 2.425 2.425 0 01-.318.476c-.136.16-.293.32-.459.484l-.174.169c-.695.676-1.397 1.333-.874 1.6h7.514v-3.338h.131s-.052-.102-.131-.302v-.035h-.026c-.393-1.031-1.31-4.222.157-9.137 1.786-6.067 8.732-9.098 8.732-9.098l.126.445h-.026l5.449 18.221c0 .071 0 .142-.022.218a3.022 3.022 0 01-.266.88c-.336.706-.917 1.537-1.17 2.159a2.048 2.048 0 00-.092.263c-.03.1-.04.206-.031.311a.379.379 0 00.074.182.347.347 0 00.158.115h.1l.21-.035h.009zm-2.105-51.876a4.789 4.789 0 00-.436-.218v-2.205a3.026 3.026 0 00-.048-.502 6.14 6.14 0 001.309-.857 91.333 91.333 0 01-.82 3.782h-.005z"
          fill="url(#prefix__paint13_linear)"
        />
        <path
          d="M142.275 146.039s-1.309-1.12 0-3.138c1.31-2.018 3.742-.444 3.742-.444s.873 2.911 0 3.582c-.873.671-3.742 0-3.742 0z"
          fill="#CA7070"
        />
        <path
          d="M155.879 220.993h-6.064a2.047 2.047 0 01-.572 1.587c-.816.96-2.458 2.12-1.685 2.515h8.321v-4.102z"
          fill="#00695C"
        />
        <path
          opacity={0.2}
          d="M149.684 222.58a2.047 2.047 0 00.572-1.587h-.436a2.047 2.047 0 01-.572 1.587c-.817.96-2.458 2.12-1.686 2.515h.437c-.773-.395.869-1.551 1.685-2.515z"
          fill="#fff"
        />
        <path
          d="M177.473 219.722l-5.676.938c.157.688.066 1.41-.257 2.035-.62 1.334-2.013 2.996-1.175 3.356l8.217-1.334-1.109-4.995zM174.705 143.306s6.492 20.847-4.397 32.388l-3.143-2.448s6.435-22.754 2.833-28.096c6.357-2.156 4.707-1.844 4.707-1.844z"
          fill="#00695C"
        />
        <path
          d="M170.217 145.145s-1.31-1.12 0-3.137c1.31-2.018 3.741-.445 3.741-.445s.874 2.911 0 3.582c-.873.671-3.741 0-3.741 0z"
          fill="#CA7070"
        />
        <path
          opacity={0.2}
          d="M171.976 222.7a2.99 2.99 0 00.258-2.04l5.239-.889v-.071l-5.676.96c.157.688.066 1.41-.257 2.035-.62 1.334-2.013 2.996-1.175 3.356l.345-.058c-.624-.444.673-2.04 1.266-3.293z"
          fill="#fff"
        />
        <path
          d="M167.907 165.864c0-1.733-1.379-3.138-3.08-3.138s-3.08 1.405-3.08 3.138v3.017c0 1.733 1.379 3.138 3.08 3.138s3.08-1.405 3.08-3.138v-3.017z"
          fill="#CA7070"
        />
        <path
          opacity={0.2}
          d="M167.606 174.588s6.357-22.474 2.895-27.998c-.306-.058-.502-.103-.502-.103l-.057-.053-.162.053c3.602 5.333-2.833 28.096-2.833 28.096l3.143 2.449.275-.302-2.759-2.142z"
          fill="#fff"
        />
        <path
          d="M164.939 165.975c3.766 0 6.819-3.108 6.819-6.942s-3.053-6.941-6.819-6.941c-3.767 0-6.82 3.107-6.82 6.941 0 3.834 3.053 6.942 6.82 6.942z"
          fill="#CA7070"
        />
        <path
          opacity={0.2}
          d="M162.515 168.886v-3.022c.001-.221.024-.442.07-.658a6.886 6.886 0 01-3.044-3.196 7.055 7.055 0 01-.511-4.42 6.968 6.968 0 012.231-3.828 6.76 6.76 0 014.057-1.662h-.384c-1.53 0-3.015.523-4.218 1.486a6.952 6.952 0 00-2.412 3.822 7.06 7.06 0 00.426 4.522 6.892 6.892 0 003.082 3.285 3.232 3.232 0 00-.07.658v3.022a3.132 3.132 0 001.035 2.362 3.01 3.01 0 002.432.749 3.075 3.075 0 01-1.924-1.043 3.181 3.181 0 01-.77-2.077z"
          fill="#fff"
        />
        <path
          d="M171.867 193.631s-13.154 1.511-13.639 0c-3.409-10.639 0-19.034 0-19.034 0-1.841.719-3.607 1.998-4.909a6.758 6.758 0 014.822-2.033 6.76 6.76 0 014.822 2.033 7.006 7.006 0 011.997 4.909v19.034z"
          fill="#00695C"
        />
        <path
          d="M171.868 193.631l5.941 27.771h-5.941l-6.161-20.603s-7.701 3.36-9.679 10.08c-1.978 6.719 0 10.523 0 10.523h-6.383l-.065-.302a29.384 29.384 0 01.713-14.911 28.947 28.947 0 017.931-12.558"
          fill="#263238"
        />
        <path
          opacity={0.2}
          d="M158.997 193.631c-3.41-10.639 0-19.034 0-19.034a7.002 7.002 0 011.843-4.748 6.771 6.771 0 014.535-2.181h-.437a6.763 6.763 0 00-4.822 2.033 7.006 7.006 0 00-1.997 4.909s-3.41 8.399 0 19.034c.175.542 1.973.693 4.209.671-1.817-.04-3.192-.218-3.331-.684z"
          fill="#fff"
        />
        <path
          d="M158.119 174.481s-17.599-12.541-15.839-28.442h3.96s9.456 20.847 15.516 22.847c6.06 2-3.637 5.595-3.637 5.595z"
          fill="#00695C"
        />
        <g opacity={0.2} fill="#fff">
          <path
            opacity={0.2}
            d="M165.82 201.288l6.047 20.225h.873l-6.16-20.603s-.284.125-.76.378zM159.106 193.742h-.874a28.947 28.947 0 00-7.931 12.558 29.384 29.384 0 00-.713 14.911l.065.302h.874l-.066-.302a29.384 29.384 0 01.713-14.911 28.94 28.94 0 017.932-12.558z"
          />
        </g>
        <path
          opacity={0.2}
          d="M142.939 146.265h-.659c-1.747 15.901 15.839 28.443 15.839 28.443l.437-.169c-2.039-1.533-17.263-13.43-15.617-28.274z"
          fill="#fff"
        />
        <path
          d="M159.499 155.931c.38.894.647 1.833.794 2.796.437 1.946 1.423 3.888 3.122 4.888.94.52 1.986.81 3.056.849 1.624.102 3.383-.218 4.532-1.391a5.756 5.756 0 001.384-2.84 9.784 9.784 0 00-.138-4.739 9.659 9.659 0 00-2.347-4.096 8.326 8.326 0 00-4.102-2.212 8.235 8.235 0 00-4.629.35 8.252 8.252 0 01-1.655.613 2.696 2.696 0 01-1.306-.108 2.74 2.74 0 01-1.108-.709 1.57 1.57 0 00.234 1.385c.143.195.33.354.545.462.215.109.452.164.692.161a4.174 4.174 0 01-3.257.178 2.785 2.785 0 001.473 1.407 2.718 2.718 0 002.02.011 9.174 9.174 0 01-3.93.818c.284 0 .839.533 1.184.64.433.07.871.101 1.309.093.448.028.881.176 1.255.43.373.254.674.604.872 1.014z"
          fill="#263238"
        />
        <g opacity={0.2} fill="#fff">
          <path
            opacity={0.2}
            d="M158.591 151.332a4.156 4.156 0 01-1.615.422 4.172 4.172 0 002.056-.422 1.526 1.526 0 01-1.138-.501 1.596 1.596 0 01-.408-1.193 2.612 2.612 0 01-.366-.315 1.57 1.57 0 00.234 1.385 1.518 1.518 0 001.237.624zM159.97 150.154a8.252 8.252 0 001.655-.613 7.46 7.46 0 012.619-.538 7.527 7.527 0 00-3.056.538 8.22 8.22 0 01-1.654.613c-.079 0-.158 0-.236.027.224.02.45.011.672-.027zM156.482 154.398c-.345-.102-.899-.631-1.183-.64a9.173 9.173 0 003.929-.818c-.277.117-.573.18-.873.187a9.158 9.158 0 01-3.493.631c.284 0 .839.533 1.183.64.3.074.61.1.917.076a1.908 1.908 0 01-.48-.076zM166.921 164.469a6.837 6.837 0 01-3.056-.849c-1.699-1.009-2.668-2.951-3.122-4.889a11.597 11.597 0 00-.795-2.795 2.571 2.571 0 00-.884-1.016 2.516 2.516 0 00-1.268-.42 4.475 4.475 0 00-.655 0h.214c.452.023.89.168 1.268.42.378.253.684.603.884 1.016.381.894.648 1.833.795 2.795.437 1.947 1.423 3.889 3.122 4.889.94.519 1.986.81 3.056.849h.764-.323zM158.08 153.109a2.746 2.746 0 01-1.298-.438 2.81 2.81 0 01-.937-1.015 3.817 3.817 0 01-.511-.147c.244.519.638.95 1.128 1.236a2.74 2.74 0 001.618.364z"
          />
        </g>
        <path
          opacity={0.2}
          d="M142.716 146.039s-1.309-1.12 0-3.138c.174-.289.413-.531.697-.708.284-.177.605-.283.936-.31a2.11 2.11 0 00-1.18.202 2.159 2.159 0 00-.889.816c-1.31 2.018 0 3.138 0 3.138.85.193 1.718.292 2.589.293a12.931 12.931 0 01-2.153-.293z"
          fill="#fff"
        />
        <path
          opacity={0.2}
          d="M16.14 146.146l.036-.121s-.446-.089-.035.121z"
          fill="url(#prefix__paint14_linear)"
        />
        <path
          opacity={0.2}
          d="M57.28 153.594a2.962 2.962 0 00-.157-.414c0-.044-.044-.08-.065-.12a2.608 2.608 0 00-.131-.231l-.088-.115a2.27 2.27 0 00-.144-.174l-.1-.102a2.057 2.057 0 00-.157-.133l-.11-.08-.174-.107-.11-.058-.196-.084-.1-.04a2.346 2.346 0 00-.284-.08 4.443 4.443 0 00-1.917.053s-1.829 2.747-1.126 3.733l-.231-.071s-13.591 15.439-21.258 18.306a7.48 7.48 0 00-.607-.383v-2.888a3.472 3.472 0 000-.365 3.435 3.435 0 00-.056-.342l.056-.031.227-.129.328-.204.21-.138c.157-.11.302-.225.436-.347l.17-.151c.105-.089.205-.182.301-.28l.175-.173c.122-.127.239-.258.35-.391l.122-.151c.104-.134.205-.27.3-.409l.123-.187c.087-.136.17-.275.249-.418l.078-.137c.096-.183.188-.374.267-.569l.07-.173a9.51 9.51 0 00.17-.476c0-.058.04-.111.052-.169.061-.209.118-.418.162-.635 0-.045 0-.085.022-.129a6.82 6.82 0 00.083-.551v-.187c0-.227.035-.444.035-.689a7.642 7.642 0 00-1.65-4.751c.58-.924.96-1.471.96-1.471a30.36 30.36 0 00-1.035-.684l-.332-.2c-.227-.138-.436-.276-.68-.4l-.38-.204a15.024 15.024 0 00-.608-.316l-.388-.182-.58-.258-.38-.155a18.046 18.046 0 00-.572-.214l-.358-.124c-.197-.062-.393-.12-.586-.174l-.318-.088c-.219-.054-.437-.098-.65-.143l-.232-.049c-.293-.053-.58-.093-.873-.12a10.194 10.194 0 00-5.24.818c.088-2.124.437-3.875 1.17-4.959l-.178-.063-.061.063s-.214.048-.55.111a4.63 4.63 0 00-.284.537c.146-.751.43-1.469.834-2.115l-.18-.062c.258-.271 1.192-1.44-.06-3.356-1.441-2.195-4.078-.488-4.078-.488a11.53 11.53 0 00-.41 2.222 6.222 6.222 0 01-.437-.196 56.248 56.248 0 00-2.048 13.937c-4.754 6.871-6.719 17.012-7.103 19.199l-.03.173-.04.244 12.36.294v20.052l-8.998 19.372s3.422.111 8.574.782l-1.423 10.359-.476 2.906h8.566c.952-1.937-3.807-2.906-3.807-2.906h-.105l1.856-9.666c.82.139 1.665.287 2.532.444 1.271.251 2.56.399 3.855.445 1.072.038 2.145-.01 3.209-.142.629 5.239-.197 8.368-.354 8.888h-.048l-.476 2.906h8.566c.83-1.688-2.68-2.644-3.593-2.857l.04-.285a49.48 49.48 0 00.335-9.866 11.696 11.696 0 003.057-1.853l.117-.106.035-.036-6.378-18.221c1.192-5.155-2.956-10.568-.742-13.275 2.213-2.706.873-6.159.61-6.75 5.99-2.667 18.097-9.333 21.494-20.888.25-.812.452-1.639.607-2.475 0 0 1.711-.707.97-3.235z"
          fill="url(#prefix__paint15_linear)"
        />
        <path
          d="M17.499 149.527s-6.492 20.848 4.396 32.389l3.143-2.449s-6.435-22.754-2.833-28.095c-6.357-2.156-4.706-1.845-4.706-1.845z"
          fill="#FF5252"
        />
        <path
          d="M21.987 151.367s1.31-1.12 0-3.137c-1.31-2.018-3.742-.445-3.742-.445s-.873 2.911 0 3.582c.873.671 3.742 0 3.742 0zM24.296 175.103c0 1.733 1.38 3.138 3.08 3.138 1.701 0 3.08-1.405 3.08-3.138v-3.017c0-1.733-1.378-3.138-3.08-3.138-1.7 0-3.08 1.405-3.08 3.138v3.017z"
          fill="#F6B9AD"
        />
        <path
          opacity={0.2}
          d="M24.597 180.809s-6.357-22.474-2.894-27.998c.305-.057.502-.102.502-.102l.057-.053.161.053c-3.602 5.333 2.834 28.096 2.834 28.096l-3.144 2.449-.275-.302 2.76-2.143z"
          fill="#fff"
        />
        <path
          d="M27.265 172.197c3.766 0 6.82-3.108 6.82-6.942s-3.054-6.942-6.82-6.942c-3.767 0-6.82 3.108-6.82 6.942s3.053 6.942 6.82 6.942z"
          fill="#F6B9AD"
        />
        <path
          opacity={0.2}
          d="M29.688 175.108v-3.022c0-.222-.023-.442-.07-.658a6.885 6.885 0 003.044-3.196 7.053 7.053 0 00.512-4.42 6.972 6.972 0 00-2.232-3.829 6.758 6.758 0 00-4.057-1.661h.384a6.75 6.75 0 014.218 1.485 6.958 6.958 0 012.412 3.822 7.055 7.055 0 01-.426 4.522 6.895 6.895 0 01-3.082 3.286c.046.216.07.436.07.658v3.022c.004.446-.086.888-.265 1.295a3.1 3.1 0 01-.77 1.066 3.008 3.008 0 01-2.432.749 3.074 3.074 0 001.925-1.043c.496-.574.769-1.312.77-2.076z"
          fill="#fff"
        />
        <path
          d="M20.336 199.853s13.155 1.511 13.64 0c1.571-4.889-2.62-10.173-.524-12.755 2.183-2.667.523-6.28.523-6.28a7.004 7.004 0 00-1.997-4.908 6.759 6.759 0 00-4.822-2.033 6.758 6.758 0 00-4.822 2.033 7.004 7.004 0 00-1.998 4.908v19.035z"
          fill="#FF5252"
        />
        <path
          opacity={0.2}
          d="M33.469 187.098c2.183-2.666.524-6.28.524-6.28a7.004 7.004 0 00-1.998-4.908 6.758 6.758 0 00-4.822-2.033c-.148 0-.292 0-.436.022a6.764 6.764 0 014.536 2.175 7.002 7.002 0 011.847 4.744s1.659 3.614-.524 6.28c-2.113 2.582 2.096 7.862.524 12.755-.149.466-1.506.644-3.31.671 2.223.022 4.013-.129 4.183-.671 1.59-4.898-2.637-10.173-.524-12.755z"
          fill="#fff"
        />
        <path
          d="M31.186 199.408c4.802 6.929 6.928 17.399 5.553 27.469l-.04.303H32.6s1.27-3.809 0-10.524a16.654 16.654 0 00-6.217-10.079l-3.955 20.603h-3.816l3.816-27.772h8.758zM54.307 159.469s1.585-.676.904-3c-.681-2.324-3.449-1.542-3.449-1.542s-1.68 2.52-1.03 3.426c.65.907 3.575 1.116 3.575 1.116z"
          fill="#F6B9AD"
        />
        <path
          d="M30.972 181.938s20.436-6.741 23.33-22.469l-3.784-1.182s-15.04 17.092-21.393 17.212c-6.352.12 1.847 6.439 1.847 6.439z"
          fill="#FF5252"
        />
        <path
          opacity={0.2}
          d="M53.608 159.487l.634.195c-2.895 15.728-23.332 22.47-23.332 22.47l-.362-.289c2.414-.853 20.362-7.706 23.06-22.376z"
          fill="#fff"
        />
        <g opacity={0.2} fill="#fff">
          <path
            opacity={0.2}
            d="M25.505 206.577L21.55 227.18h.873l3.842-19.999a9.543 9.543 0 00-.76-.604zM31.185 199.408h-.873c4.802 6.929 6.929 17.399 5.553 27.469l-.039.303h.873l.04-.303c1.375-10.07-.743-20.54-5.554-27.469z"
          />
        </g>
        <path
          opacity={0.2}
          d="M53.883 159.331s1.585-.675.904-3a2.167 2.167 0 00-.46-.886 2.112 2.112 0 00-.806-.576c.4.075.772.264 1.07.546.299.282.512.644.615 1.045.681 2.32-.903 3-.903 3a11.743 11.743 0 01-2.559-.489c.702.18 1.418.301 2.14.36z"
          fill="#fff"
        />
        <path
          d="M20.336 199.097l-8.295 17.777c4.838.245 9.652.839 14.407 1.777 9.169 1.778 13.535-2.666 13.535-2.666l-5.916-16.888h-13.73z"
          fill="#263238"
        />
        <path
          d="M22.537 227.095s4.366.889 3.492 2.667h-7.858l.437-2.667h3.929zM36.508 227.095s4.365.889 3.492 2.667h-7.858l.436-2.667h3.93z"
          fill="#FF5252"
        />
        <path
          d="M33.451 159.544s-10.478 15.11-5.675 21.332l-18.774-.444s5.24-34.22 24.45-20.888z"
          fill="#FCCC63"
        />
        <path
          opacity={0.2}
          d="M33.451 159.544c-2.707-1.88-5.134-2.813-7.313-3.031a18.365 18.365 0 015.13 2.587s-10.478 15.11-5.675 21.332l-16.525-.391c-.044.253-.066.391-.066.391l18.774.444c-4.803-6.222 5.675-21.332 5.675-21.332zM34.089 199.097h-1.31l5.916 16.888s-2.82 2.866-8.688 3.071c6.754.222 9.998-3.071 9.998-3.071l-5.916-16.888zM22.537 227.095h-.873s4.365.889 3.492 2.667h.873c.874-1.778-3.492-2.667-3.492-2.667zM36.508 227.095h-.874s4.366.889 3.493 2.667H40c.873-1.778-3.492-2.667-3.492-2.667z"
          fill="#fff"
        />
        <path d="M385.778 74.52H218.564v6.443h167.214V74.52z" fill="#F5F5F5" />
        <path
          d="M389 72.462H215.238V292.89H389V72.461z"
          fill="url(#prefix__paint16_linear)"
        />
        <path d="M385.778 80.963H218.564v204.208h167.214V80.963z" fill="#fff" />
        <path
          d="M222.442 79.408c.844 0 1.528-.697 1.528-1.556 0-.859-.684-1.555-1.528-1.555s-1.528.696-1.528 1.555c0 .86.684 1.556 1.528 1.556z"
          fill="#FF5252"
        />
        <path
          d="M226.642 79.408c.844 0 1.528-.697 1.528-1.556 0-.859-.684-1.555-1.528-1.555s-1.528.696-1.528 1.555c0 .86.684 1.556 1.528 1.556z"
          fill="#FF0"
        />
        <path
          d="M230.846 79.408c.844 0 1.528-.697 1.528-1.556 0-.859-.684-1.555-1.528-1.555s-1.528.696-1.528 1.555c0 .86.684 1.556 1.528 1.556z"
          fill="#69F0AE"
        />
        <path
          opacity={0.2}
          d="M375.737 90.074H229.043v4h146.694v-4z"
          fill="#BE6F72"
        />
        <path
          d="M291.475 107.406H228.17v68.439h63.305v-68.439z"
          fill="url(#prefix__paint17_linear)"
        />
        <path d="M290.165 109.628h-60.686v63.995h60.686v-63.995z" fill="#fff" />
        <path
          d="M375.736 141.626h-63.305v68.439h63.305v-68.439z"
          fill="url(#prefix__paint18_linear)"
        />
        <path d="M374.426 143.848h-60.685v63.995h60.685v-63.995z" fill="#fff" />
        <path
          d="M378.356 226.064H229.479v47.108h148.877v-47.108z"
          fill="url(#prefix__paint19_linear)"
        />
        <path
          opacity={0.5}
          d="M375.737 229.175H232.536v42.219h143.201v-42.219z"
          fill="#BE6F72"
        />
        <path
          opacity={0.5}
          d="M236.028 233.175h139.709v-4H232.536v42.219h3.492v-38.219z"
          fill="#fff"
        />
        <path
          d="M280.111 123.649c-4.141-4.899-9.842-8.161-16.107-9.215a26.67 26.67 0 00-18.162 3.45c-5.469 3.283-9.631 8.419-11.757 14.508a28.023 28.023 0 00.126 18.807c2.208 6.06 6.438 11.137 11.951 14.343a26.656 26.656 0 0018.207 3.198c6.249-1.141 11.906-4.481 15.981-9.438 4.074-4.957 6.308-11.213 6.309-17.676.008-6.599-2.316-12.979-6.548-17.977zm-10.915 34.429a18.5 18.5 0 01-11.836 2.529 18.639 18.639 0 01-10.895-5.342 19.238 19.238 0 01-5.434-10.998 19.399 19.399 0 012.283-12.089 18.887 18.887 0 019.052-8.164 18.468 18.468 0 0112.065-.85 18.754 18.754 0 0110.071 6.817 19.328 19.328 0 013.897 11.653 19.292 19.292 0 01-2.445 9.467 18.864 18.864 0 01-6.745 6.977h-.013z"
          fill="url(#prefix__paint20_linear)"
        />
        <path
          d="M273.16 129.742l5.96-5.222a25.74 25.74 0 00-8.778-6.732 25.326 25.326 0 00-10.738-2.383v8a17.59 17.59 0 017.459 1.659 17.885 17.885 0 016.097 4.678z"
          fill="#FF5252"
        />
        <path
          d="M259.604 159.842a17.528 17.528 0 01-7.387-1.631l-3.244 7.293a25.357 25.357 0 0023.79-1.333l-4.017-6.884a17.548 17.548 0 01-9.142 2.555z"
          fill="#69F0AE"
        />
        <path
          d="M285.363 141.621c.007-6.281-2.209-12.354-6.244-17.105l-5.959 5.221a18.298 18.298 0 013.679 6.948c.713 2.562.863 5.252.442 7.88a18.356 18.356 0 01-2.878 7.328 18.005 18.005 0 01-5.657 5.398l4.017 6.884a26.013 26.013 0 009.232-9.579 26.593 26.593 0 003.368-12.975z"
          fill="#FF9800"
        />
        <path
          d="M241.704 141.621c0-4.832 1.886-9.467 5.243-12.884s7.91-5.337 12.657-5.337v-7.999a25.479 25.479 0 00-16.177 5.816c-4.581 3.764-7.757 9.011-9 14.869a26.646 26.646 0 002.169 17.324c2.647 5.352 7.015 9.621 12.377 12.094l3.244-7.293a17.994 17.994 0 01-7.655-6.72 18.46 18.46 0 01-2.858-9.87z"
          fill="#BE6F72"
        />
        <path
          d="M368.314 153.18h-46.278v8h46.278v-8z"
          fill="url(#prefix__paint21_linear)"
        />
        <path d="M367.878 153.625h-45.405v7.11h45.405v-7.11z" fill="#BE6F72" />
        <path d="M355.653 165.624h-33.18v7.111h33.18v-7.111z" fill="#FF5252" />
        <path
          d="M345.175 177.623h-22.702v7.111h22.702v-7.111z"
          fill="#69F0AE"
        />
        <path
          d="M363.512 189.622h-41.039v7.111h41.039v-7.111z"
          fill="#FF9800"
        />
        <path
          d="M294.531 186.511h-65.052v4h65.052v-4zM266.153 193.177h-36.674v4h36.674v-4zM285.363 193.177h-12.661v4h12.661v-4zM285.363 207.843h-12.661v4h12.661v-4zM266.153 206.51h-36.674v4h36.674v-4zM294.531 199.844h-65.052v3.999h65.052v-3.999zM376.61 107.85h-65.052v4h65.052v-4zM348.231 114.516h-36.673v4h36.673v-4zM367.441 114.516H354.78v4h12.661v-4zM367.441 129.182H354.78v4h12.661v-4zM348.231 127.849h-36.673v3.999h36.673v-3.999zM376.61 121.183h-65.052v3.999h65.052v-3.999z"
          fill="#F5F5F5"
        />
        <path
          d="M332.078 310.947c2.652 0 4.802-2.189 4.802-4.889 0-2.699-2.15-4.888-4.802-4.888-2.652 0-4.803 2.189-4.803 4.888 0 2.7 2.151 4.889 4.803 4.889z"
          fill="url(#prefix__paint22_linear)"
        />
        <path
          d="M332.078 309.614c1.929 0 3.492-1.592 3.492-3.556 0-1.963-1.563-3.555-3.492-3.555s-3.493 1.592-3.493 3.555c0 1.964 1.564 3.556 3.493 3.556z"
          fill="#FF5252"
        />
        <path
          d="M340.373 251.84H190.187v53.774h150.186V251.84z"
          fill="url(#prefix__paint23_linear)"
        />
        <path
          d="M337.753 254.062H194.552v42.219h143.201v-42.219z"
          fill="#fff"
        />
        <path
          d="M199.355 288.282h132.723"
          stroke="#BE6F72"
          strokeWidth={3}
          strokeMiterlimit={10}
        />
        <path
          d="M220.311 262.506h-19.646v24.443h19.646v-24.443z"
          fill="url(#prefix__paint24_linear)"
        />
        <path
          d="M219.219 263.617h-17.463v22.665h17.463v-22.665z"
          fill="#BE6F72"
        />
        <path
          d="M328.585 279.838h-17.463v7.111h17.463v-7.111z"
          fill="#69F0AE"
        />
        <path
          d="M295.841 270.505h-17.464v15.999h17.464v-15.999z"
          fill="#FF9800"
        />
        <path
          d="M257.421 273.172h-17.463v13.332h17.463v-13.332zM337.753 296.281H194.552v6.222h143.201v-6.222z"
          fill="#FF5252"
        />
        <path
          d="M200.665 310.947c2.652 0 4.802-2.189 4.802-4.889 0-2.699-2.15-4.888-4.802-4.888-2.653 0-4.803 2.189-4.803 4.888 0 2.7 2.15 4.889 4.803 4.889z"
          fill="url(#prefix__paint25_linear)"
        />
        <path
          d="M200.665 309.614c1.929 0 3.492-1.592 3.492-3.556 0-1.963-1.563-3.555-3.492-3.555s-3.493 1.592-3.493 3.555c0 1.964 1.564 3.556 3.493 3.556zM194.552 255.84h-3.492v46.663h3.492V255.84z"
          fill="#FF5252"
        />
        <path
          opacity={0.2}
          d="M194.552 255.84h-3.492v46.663h3.492V255.84z"
          fill="#000"
        />
        <path
          d="M194.784 260.799v-.142-.218c0-.071 0-.093-.026-.137-.027-.045-.031-.134-.053-.196s-.026-.084-.043-.129l-.079-.186-.052-.111a2.567 2.567 0 00-.114-.183l-.057-.084a2.898 2.898 0 00-.183-.231 4.21 4.21 0 00-1.218-.916c.358-.391.625-.859.781-1.369.046-.136.081-.276.105-.417v-.129c.012-.086.019-.172.022-.258v-.142-.218c0-.071 0-.093-.026-.138-.026-.044-.031-.133-.053-.195-.021-.062-.026-.085-.043-.129l-.079-.187-.052-.111a2.418 2.418 0 00-.114-.182l-.056-.084a2.974 2.974 0 00-.184-.232 4.391 4.391 0 00-1.55-1.066s-2.772 1.044-2.955 2.191c-2.035.444-13.893 2.955-22.035 2.755l-.061-.164a7.468 7.468 0 00-1.038-3.805 7.295 7.295 0 00-2.817-2.715v-2.791a3.503 3.503 0 000-.355 3.21 3.21 0 00-.053-.338l.053-.031.222-.125.323-.2.206-.137c.151-.107.297-.22.436-.338l.166-.147c.101-.089.197-.177.293-.271l.17-.169c.119-.124.233-.252.34-.382l.118-.151c.102-.13.2-.264.293-.4l.118-.182c.084-.133.166-.27.244-.409l.074-.133c.097-.178.184-.365.262-.551l.066-.169c.061-.151.116-.3.166-.445l.052-.164c.061-.205.114-.409.157-.618 0-.04 0-.084.022-.124a8.71 8.71 0 00.079-.538v-.182c0-.222.035-.445.035-.671a7.447 7.447 0 00-.93-3.605c.467-.115.751-.208.716-.253a13.073 13.073 0 00-.546-.698l-.179-.208c-.131-.152-.258-.294-.389-.445l-.209-.218a10.538 10.538 0 00-.393-.377l-.205-.187a20.14 20.14 0 00-.498-.413l-.109-.089c-.201-.151-.402-.294-.607-.445l-.227-.142a5.26 5.26 0 00-.402-.235l-.27-.143-.376-.182-.275-.124c-.131-.058-.266-.107-.401-.156l-.249-.093a9.87 9.87 0 00-.603-.182l-.31-.071-.336-.072-.336-.053-.31-.035-.345-.031H158.215c-.189 0-.378.008-.567.026-4.467.373-8.379 4.342-8.379 10.666v5.217h6.986v2.374a7.273 7.273 0 00-3.065 2.718 7.465 7.465 0 00-1.144 3.97v20.225l-5.929 27.727h-.078l-1.166 5.293 8.365 1.378.362.058c.874-.383-.589-2.174-1.248-3.556a3.688 3.688 0 01-.341-1.306l6.427-21.461h-.031l.153-.502s8.182 3.555 10.286 10.706c1.707 5.777.646 9.537.183 10.755h-.03v.071c-.092.231-.157.36-.157.36h.157v3.924h8.845c.821-.422-.921-1.653-1.79-2.667a2.533 2.533 0 01-.576-1.133h.148l.07-.32a31.432 31.432 0 00-.74-15.845 30.982 30.982 0 00-8.367-13.384.356.356 0 00.039-.075 33.619 33.619 0 001.533-8.027c6.762.658 15.761.187 22.488-5.119a20.893 20.893 0 001.838-1.591c.581-.045 1.598-.374 2.162-2.045.045-.136.08-.276.104-.417v-.129c.016-.094.026-.189.031-.285z"
          fill="url(#prefix__paint26_linear)"
        />
        <path
          d="M159.35 268.63s20.476 6.626 31.819-4.444l-2.406-3.204s-22.004 4.99-27.247 1.333c-5.244-3.658-2.166 6.315-2.166 6.315z"
          fill="#BE6F72"
        />
        <path
          opacity={0.2}
          d="M190.593 263.768l.401.533c-11.351 11.075-31.818 4.445-31.818 4.445s-.052-.169-.131-.445c2.44.742 20.965 5.813 31.548-4.533z"
          fill="#fff"
        />
        <path
          d="M190.732 264.181s1.677.387 2.449-1.902c.773-2.288-1.921-3.297-1.921-3.297s-2.807 1.053-2.798 2.173c.009 1.12 2.27 3.026 2.27 3.026z"
          fill="#985454"
        />
        <path
          opacity={0.2}
          d="M190.466 263.821s1.677.387 2.449-1.902a2.174 2.174 0 00-.196-1.937c.283.297.478.671.56 1.078.082.406.048.827-.097 1.215-.773 2.293-2.45 1.902-2.45 1.902a12.083 12.083 0 01-1.798-1.915c.467.562.98 1.084 1.532 1.559z"
          fill="#fff"
        />
        <path
          d="M169.047 305.432h6.064c-.022.291.017.583.116.857s.254.522.456.729c.816.96 2.458 2.12 1.685 2.516h-8.321v-4.102z"
          fill="#BE6F72"
        />
        <path
          opacity={0.2}
          d="M175.242 307.018a2.03 2.03 0 01-.456-.729 2.063 2.063 0 01-.116-.857h.437a2.032 2.032 0 00.572 1.586c.816.96 2.458 2.12 1.685 2.516h-.437c.773-.396-.868-1.551-1.685-2.516z"
          fill="#fff"
        />
        <path
          d="M147.449 304.161l5.675.946a2.997 2.997 0 00.258 2.036c.62 1.333 2.013 2.995 1.174 3.355l-8.216-1.333 1.109-5.004z"
          fill="#BE6F72"
        />
        <path
          opacity={0.2}
          d="M152.95 307.138a2.988 2.988 0 01-.257-2.035l-5.261-.889v-.071l5.675.947a2.988 2.988 0 00.258 2.035c.62 1.333 2.013 2.995 1.174 3.355l-.345-.057c.647-.436-.65-2.031-1.244-3.285z"
          fill="#fff"
        />
        <path
          d="M157.019 253.32c0 1.733 1.379 3.138 3.08 3.138s3.08-1.405 3.08-3.138v-3.018c0-1.732-1.379-3.137-3.08-3.137s-3.08 1.405-3.08 3.137v3.018z"
          fill="#985454"
        />
        <path
          d="M159.987 250.414c3.767 0 6.82-3.108 6.82-6.942s-3.053-6.942-6.82-6.942c-3.766 0-6.819 3.108-6.819 6.942s3.053 6.942 6.819 6.942z"
          fill="#985454"
        />
        <path
          opacity={0.2}
          d="M162.411 253.324v-3.022c0-.221-.024-.441-.07-.657a6.895 6.895 0 003.044-3.196 7.058 7.058 0 00.511-4.421 6.972 6.972 0 00-2.231-3.828 6.753 6.753 0 00-4.057-1.661h.384a6.745 6.745 0 014.218 1.485 6.96 6.96 0 012.412 3.822 7.06 7.06 0 01-.426 4.522 6.894 6.894 0 01-3.082 3.286c.046.216.069.436.07.657v3.022a3.128 3.128 0 01-1.035 2.362 3.01 3.01 0 01-2.432.749 3.07 3.07 0 001.924-1.043c.496-.574.77-1.312.77-2.077z"
          fill="#fff"
        />
        <path
          d="M153.059 278.069s13.154 1.511 13.639 0c3.41-10.639 0-19.034 0-19.034a7.002 7.002 0 00-1.997-4.908 6.76 6.76 0 00-4.822-2.034 6.76 6.76 0 00-4.823 2.034 7.006 7.006 0 00-1.997 4.908v19.034z"
          fill="#BE6F72"
        />
        <path
          d="M153.059 278.069l-5.942 27.772h5.942l6.16-20.603s7.702 3.36 9.68 10.079c1.977 6.72 0 10.524 0 10.524h6.391l.066-.302a29.387 29.387 0 00-.713-14.912 28.958 28.958 0 00-7.932-12.558"
          fill="#263238"
        />
        <path
          opacity={0.2}
          d="M165.93 278.069c3.41-10.639 0-19.034 0-19.034a7.012 7.012 0 00-1.844-4.748 6.768 6.768 0 00-4.535-2.18h.437c1.809 0 3.543.731 4.822 2.033a7.004 7.004 0 011.997 4.908s3.41 8.4 0 19.035c-.174.542-1.973.693-4.208.671 1.816-.04 3.182-.218 3.331-.685z"
          fill="#fff"
        />
        <g opacity={0.2} fill="#fff">
          <path
            opacity={0.2}
            d="M159.106 285.726l-6.047 20.226h-.873l6.16-20.603s.284.124.76.377zM165.821 278.18h.873a28.953 28.953 0 017.931 12.558 29.376 29.376 0 01.713 14.912l-.065.302h-.873l.065-.302a29.387 29.387 0 00-.713-14.912 28.953 28.953 0 00-7.931-12.558z"
          />
        </g>
        <path
          d="M158.477 264.186s20.476 6.626 31.819-4.444l-2.406-3.204s-22.004 4.99-27.247 1.333c-5.244-3.658-2.166 6.315-2.166 6.315z"
          fill="#BE6F72"
        />
        <path
          opacity={0.2}
          d="M189.719 259.324l.402.533c-11.351 11.075-31.819 4.444-31.819 4.444s-.052-.168-.131-.444c2.441.742 20.965 5.813 31.548-4.533z"
          fill="#fff"
        />
        <path
          d="M189.859 259.737s1.677.387 2.449-1.902c.773-2.289-1.921-3.297-1.921-3.297s-2.807 1.053-2.798 2.173c.009 1.12 2.27 3.026 2.27 3.026z"
          fill="#985454"
        />
        <path
          opacity={0.2}
          d="M189.592 259.377s1.677.387 2.45-1.902c.119-.316.164-.656.13-.993a2.163 2.163 0 00-.327-.944c.284.297.478.671.56 1.078.082.406.048.827-.097 1.215-.773 2.293-2.449 1.902-2.449 1.902a12.008 12.008 0 01-1.799-1.916c.467.563.98 1.085 1.532 1.56z"
          fill="#fff"
        />
        <path
          d="M160.499 241.17l-.437 9.332h-9.605v-4.955c0-9.95 10.334-13.728 16.154-5.733.144.218-6.112 1.356-6.112 1.356z"
          fill="#263238"
        />
        <path
          opacity={0.2}
          d="M158.342 235.543c2.449.205 4.968 1.565 6.959 4.298.144.195-6.112 1.333-6.112 1.333l-.437 9.333h1.31l.437-9.333s6.256-1.138 6.112-1.333c-2.345-3.227-5.427-4.515-8.269-4.298z"
          fill="#fff"
        />
      </g>
      <defs>
        <linearGradient
          id="prefix__paint0_linear"
          x1={93.264}
          y1={215.985}
          x2={93.264}
          y2={0}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity={0.25} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id="prefix__paint1_linear"
          x1={5057.27}
          y1={1984.3}
          x2={5057.27}
          y2={1930.53}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity={0.25} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id="prefix__paint2_linear"
          x1={5057.27}
          y1={2282.95}
          x2={5057.27}
          y2={2229.18}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity={0.25} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id="prefix__paint3_linear"
          x1={7328.4}
          y1={2282.95}
          x2={7328.4}
          y2={2229.18}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity={0.25} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id="prefix__paint4_linear"
          x1={2788.39}
          y1={437.747}
          x2={2788.39}
          y2={383.973}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity={0.25} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id="prefix__paint5_linear"
          x1={2788.39}
          y1={517.741}
          x2={2788.39}
          y2={463.967}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity={0.25} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id="prefix__paint6_linear"
          x1={2788.39}
          y1={597.735}
          x2={2788.39}
          y2={543.961}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity={0.25} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id="prefix__paint7_linear"
          x1={2788.39}
          y1={677.73}
          x2={2788.39}
          y2={623.956}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity={0.25} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id="prefix__paint8_linear"
          x1={34321.4}
          y1={22212.7}
          x2={34321.4}
          y2={12213.4}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity={0.25} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id="prefix__paint9_linear"
          x1={64388.9}
          y1={23654.5}
          x2={63441.9}
          y2={13432.1}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity={0.25} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id="prefix__paint10_linear"
          x1={2987.54}
          y1={1831.96}
          x2={2979.51}
          y2={1745.24}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity={0.25} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id="prefix__paint11_linear"
          x1={3258.7}
          y1={1778.37}
          x2={3250.66}
          y2={1691.65}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity={0.25} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id="prefix__paint12_linear"
          x1={266.35}
          y1={192.524}
          x2={266.35}
          y2={192.492}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity={0.25} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id="prefix__paint13_linear"
          x1={17388}
          y1={44773.8}
          x2={17388}
          y2={31504.6}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity={0.25} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id="prefix__paint14_linear"
          x1={55.959}
          y1={204.872}
          x2={55.959}
          y2={204.829}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity={0.25} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id="prefix__paint15_linear"
          x1={11548.2}
          y1={55913.8}
          x2={11548.2}
          y2={37696.2}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity={0.25} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id="prefix__paint16_linear"
          x1={120459}
          y1={145346}
          x2={120459}
          y2={36013.4}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity={0.25} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id="prefix__paint17_linear"
          x1={37902.4}
          y1={27187.6}
          x2={37902.4}
          y2={16647.9}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity={0.25} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id="prefix__paint18_linear"
          x1={50204.6}
          y1={32491.7}
          x2={50204.6}
          y2={21952}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity={0.25} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id="prefix__paint19_linear"
          x1={103865}
          y1={29182.2}
          x2={103865}
          y2={24188.8}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity={0.25} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id="prefix__paint20_linear"
          x1={40787.6}
          y1={26298.3}
          x2={40787.6}
          y2={19465}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity={0.25} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id="prefix__paint21_linear"
          x1={36910.6}
          y1={3054.42}
          x2={36910.6}
          y2={2910.43}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity={0.25} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id="prefix__paint22_linear"
          x1={7632.97}
          y1={7142.03}
          x2={7632.97}
          y2={6926.94}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity={0.25} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id="prefix__paint23_linear"
          x1={91446.4}
          y1={37231.1}
          x2={91446.4}
          y2={30724.5}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity={0.25} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id="prefix__paint24_linear"
          x1={9672.61}
          y1={16044.7}
          x2={9672.61}
          y2={14700.3}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity={0.25} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id="prefix__paint25_linear"
          x1={4610.48}
          y1={7142.03}
          x2={4610.48}
          y2={6926.94}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity={0.25} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id="prefix__paint26_linear"
          x1={24419}
          y1={56689.8}
          x2={30123.8}
          y2={56689.8}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="gray" stopOpacity={0.25} />
          <stop offset={0.54} stopColor="gray" stopOpacity={0.12} />
          <stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <clipPath id="prefix__clip0">
          <path fill="#fff" d="M0 0h389v316H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default CaughtUp;
